import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import api from "../services/api";

const LiveProtestPage = () => {
  const [protests, setProtests] = useState([]);
  const [newProtest, setNewProtest] = useState({ topic: "", date: "", description: "", area: "" });
  const [joinedProtests, setJoinedProtests] = useState([]);
  const [filter, setFilter] = useState({ search: "", date: "" });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/protests").then((res) => setProtests(res.data));
  }, []);

  const handleChange = (e) => {
    setNewProtest({ ...newProtest, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (!newProtest.topic || !newProtest.date) return;
    setLoading(true);
    try {
      const res = await api.post("/protests/create", newProtest);
      setProtests([res.data, ...protests]);
      setNewProtest({ topic: "", date: "", description: "", area: "" });
    } catch (err) {
      console.error("Failed to create protest", err);
    } finally {
      setLoading(false);
    }
  };

  const handleJoin = (protestId) => {
    if (!joinedProtests.includes(protestId)) {
      setJoinedProtests([...joinedProtests, protestId]);
    }
  };

  const today = new Date().toISOString().split("T")[0];

  const filteredProtests = protests.filter((item) =>
    (!filter.search || item.topic.toLowerCase().includes(filter.search.toLowerCase()) || item.area?.toLowerCase().includes(filter.search.toLowerCase())) &&
    (!filter.date || item.date === filter.date)
  );

  return (
    <div className="bg-gradient-to-br from-yellow-50 to-white min-h-screen py-12 px-4">
      <div className="max-w-5xl mx-auto">
        <motion.h1
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-4xl font-bold text-center text-red-700"
        >
          जनता है जागो, लोकतंत्र बचाओ! 💪🗳️
        </motion.h1>
        <p className="text-center text-sm text-gray-600 italic mb-8">
          Raise your digital protest. Be part of the movement.
        </p>

        {/* Register Section */}
        <div className="bg-white rounded-xl shadow-md p-6 mb-10 border">
          <h2 className="text-xl font-semibold text-gray-700 mb-2">Register a New Protest</h2>
          <input
            type="text"
            name="topic"
            value={newProtest.topic}
            onChange={handleChange}
            placeholder="e.g. Bijli Samasya Protest"
            className="w-full mb-3 px-4 py-2 border rounded"
          />
          <input
            type="date"
            name="date"
            value={newProtest.date}
            onChange={handleChange}
            className="w-full mb-3 px-4 py-2 border rounded"
          />
          <input
            type="text"
            name="area"
            value={newProtest.area}
            onChange={handleChange}
            placeholder="Area/Region (e.g. Patna, Bihar)"
            className="w-full mb-3 px-4 py-2 border rounded"
          />
          <textarea
            name="description"
            value={newProtest.description}
            onChange={handleChange}
            rows={3}
            className="w-full mb-3 px-4 py-2 border rounded"
            placeholder="Describe the reason of protest..."
          ></textarea>
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded shadow"
          >
            {loading ? "Posting..." : "Submit Protest"}
          </button>
        </div>

        {/* Filter Section */}
        <div className="bg-white rounded-lg p-4 shadow mb-6">
          <h2 className="text-lg font-bold mb-2">🔍 Search & Filter</h2>
          <div className="grid sm:grid-cols-2 gap-3">
            <input
              type="text"
              placeholder="Search by topic or area"
              value={filter.search}
              onChange={(e) => setFilter({ ...filter, search: e.target.value })}
              className="border px-3 py-2 rounded"
            />
            <input
              type="date"
              value={filter.date}
              onChange={(e) => setFilter({ ...filter, date: e.target.value })}
              className="border px-3 py-2 rounded"
            />
          </div>
        </div>

        {/* Protest List */}
        <div>
          <h2 className="text-2xl font-bold text-gray-800 mb-4">Upcoming Digital Protests</h2>
          <div className="grid gap-4">
            {filteredProtests.length === 0 ? (
              <p className="text-gray-500">No protests scheduled yet.</p>
            ) : (
              filteredProtests.map((item, idx) => {
                const isToday = item.date === today;
                const joined = joinedProtests.includes(item._id);

                return (
                  <div key={idx} className="p-4 border bg-white rounded shadow relative">
                    <h3 className="text-xl font-semibold text-red-700">{item.topic}</h3>
                    <p className="text-gray-600 text-sm">{item.description}</p>
                    <p className="text-sm text-gray-500">📍 Area: {item.area || "N/A"}</p>
                    <p className={`text-sm mt-1 ${isToday ? "text-red-600 font-semibold" : "text-gray-400"}`}>
                      📅 {item.date} {isToday && " — Today 🔴"}
                    </p>
                    <p className="text-sm text-green-700 mt-1">👁️ Viewers: {Math.floor(Math.random() * 900) + 100}</p>

                    <button
                      onClick={() => handleJoin(item._id)}
                      disabled={joined}
                      className={`mt-2 px-4 py-1 text-sm rounded shadow ${
                        joined ? "bg-gray-400 cursor-default text-white" : "bg-blue-600 hover:bg-blue-700 text-white"
                      }`}
                    >
                      {joined ? "Joined ✅" : "Join Protest"}
                    </button>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiveProtestPage;
